/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React from 'react';

function formatLakhs(value) {
    const num = Number(value) / 100000;
    if (num === 0) return '₹0L';
    return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}L`;
}

function fullValue(value) {
    return `₹${Number(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function PlantWise({ data = [], hasAccess = false }) {
    if (!hasAccess) return null;

    if (!data || data.length === 0) {
        return (
            <div className="bg-[#F5F5FA] mt-6 rounded-[15px] p-5">
                <p className="text-sm27 font-normal mb-5 text-[#555259]">Plant Wise</p>
                <div className="bg-white rounded-[16px] border border-[#CBC7C7] flex flex-col items-center justify-center py-16">
                    <img src="/images/Group8022.svg" alt="No data" />
                    <p className="mt-4 text-[20px] font-normal text-[#15090E]">
                        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                        It seems like there aren&apos;t any <span className="text-[#ED1C24]">Plant Wise</span> listed yet!
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-[#F5F5FA] mt-6 rounded-[15px] p-5">
            <p className="text-sm27 font-normal mb-5 text-[#555259]">Plant Wise</p>
            <div className="bg-white rounded-[16px] border border-[#CBC7C7] p-6 flex flex-col gap-2">

                {/* Header Row */}
                <div className="flex gap-3 items-center">
                    <div className="bg-[#F5F5FA] flex flex-col items-center px-6 py-3 rounded-[8px] shrink-0 w-[156.4px]">
                        <p className="text-[15px] font-normal text-[#090406] whitespace-nowrap">Sales Group</p>
                    </div>
                    <div className="flex flex-1 gap-3">
                        {['Production Group', 'Plant/WH', 'Order Value (in lakhs)', 'Billing Value (in lakhs)'].map((header) => (
                            <div key={header} className="bg-[#F5F5FA] flex flex-1 flex-col items-center px-6 py-3 rounded-[8px]">
                                <p className="text-[15px] font-normal text-[#090406] whitespace-nowrap">{header}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* One row per Sales Group */}
                {data.map((salesItem) => (
                    <div key={salesItem.sales_group} className="flex gap-3 items-start">

                        {/* Sales Group Cell */}
                        <div className="bg-white border border-[#CBC7C7] flex flex-col items-center justify-center px-6 py-3 rounded-[8px] self-stretch shrink-0 w-[156.4px]">
                            <p className="text-[15px] font-normal text-[#090406] whitespace-nowrap">{salesItem.sales_group === 'MNR' ? 'MnR' : salesItem.sales_group}</p>
                        </div>

                        {/* Right Section */}
                        <div className="flex flex-1 flex-col gap-3 min-w-0">

                            {/* 4-column data area */}
                            <div className="flex gap-3 items-start">

                                {/* Production Group Column */}
                                <div className="flex flex-1 flex-col gap-3 min-w-0">
                                    {salesItem.prod_groups.map((pg) => {
                                        const cellHeight = (pg.plants.length + 1) * 39 + pg.plants.length * 4;
                                        return (
                                            <div
                                                key={pg.prod_group}
                                                className="bg-white border border-[#CBC7C7] flex items-center justify-center px-6 rounded-[8px] w-full"
                                                style={{ height: `${cellHeight}px` }}
                                            >
                                                <p className="text-[15px] font-normal text-[#090406] whitespace-nowrap">
                                                    {pg.prod_group === 'MNR' ? 'MnR' : pg.prod_group.charAt(0).toUpperCase() + pg.prod_group.slice(1).toLowerCase()}
                                                </p>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* Plant/WH Column */}
                                <div className="flex flex-1 flex-col gap-3 min-w-0">
                                    {salesItem.prod_groups.map((pg) => (
                                        <div key={pg.prod_group} className="flex flex-col gap-1">
                                            {pg.plants.map((plant) => (
                                                <div key={plant.plant_wh} className="bg-white border border-[#CBC7C7] h-[39px] flex items-center justify-center px-6 rounded-[8px] w-full">
                                                    <p className="text-[15px] font-normal text-[#090406] whitespace-nowrap">{plant.plant_wh}</p>
                                                </div>
                                            ))}
                                            <div className="bg-[#44445E] h-[39px] flex items-center justify-center px-6 rounded-[8px] w-full">
                                                <p className="text-[15px] font-semibold text-white whitespace-nowrap">Total</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Order Value Column */}
                                <div className="flex flex-1 flex-col gap-3 min-w-0">
                                    {salesItem.prod_groups.map((pg) => (
                                        <div key={pg.prod_group} className="flex flex-col gap-1">
                                            {pg.plants.map((plant) => (
                                                <div key={plant.plant_wh} className="bg-white border border-[#CBC7C7] h-[39px] flex items-center justify-center px-6 rounded-[8px] w-full">
                                                    <p className="text-[15px] font-normal text-[#090406] whitespace-nowrap cursor-zoom-in" title={fullValue(plant.order_value)}>{formatLakhs(plant.order_value)}</p>
                                                </div>
                                            ))}
                                            <div className="bg-[#44445E] h-[39px] flex items-center justify-center px-6 rounded-[8px] w-full">
                                                <p className="text-[15px] font-semibold text-white whitespace-nowrap cursor-zoom-in" title={fullValue(pg.subtotal_order_value)}>{formatLakhs(pg.subtotal_order_value)}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Billing Value Column */}
                                <div className="flex flex-1 flex-col gap-3 min-w-0">
                                    {salesItem.prod_groups.map((pg) => (
                                        <div key={pg.prod_group} className="flex flex-col gap-1">
                                            {pg.plants.map((plant) => (
                                                <div key={plant.plant_wh} className="bg-white border border-[#CBC7C7] h-[39px] flex items-center justify-center px-6 rounded-[8px] w-full">
                                                    <p className="text-[15px] font-normal text-[#090406] whitespace-nowrap cursor-zoom-in" title={fullValue(plant.billing_value)}>{formatLakhs(plant.billing_value)}</p>
                                                </div>
                                            ))}
                                            <div className="bg-[#44445E] h-[39px] flex items-center justify-center px-6 rounded-[8px] w-full">
                                                <p className="text-[15px] font-semibold text-white whitespace-nowrap cursor-zoom-in" title={fullValue(pg.subtotal_billing_value)}>{formatLakhs(pg.subtotal_billing_value)}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Sales Group Total Row */}
                            <div className="flex gap-3">
                                {/* Production Group Column */}
                                <div className="bg-[#ED1C24] h-[39px] flex flex-1 items-center justify-center px-7 rounded-l-[8px]">
                                    <p className="text-[15px] font-semibold text-white whitespace-nowrap">Total</p>
                                </div>
                                {/* Plant/WH Column - merged with Production Group */}
                                <div className="bg-[#ED1C24] h-[39px] flex flex-1 items-center justify-center px-6 rounded-r-[8px] -ml-[12px] relative z-10" />
                                {/* Order Value Column */}
                                <div className="bg-[#ED1C24] flex flex-1 h-[39px] items-center justify-center px-6 rounded-[8px]">
                                    <p className="text-[15px] font-semibold text-white whitespace-nowrap cursor-zoom-in" title={fullValue(salesItem.total_order_value)}>{formatLakhs(salesItem.total_order_value)}</p>
                                </div>
                                {/* Billing Value Column */}
                                <div className="bg-[#ED1C24] flex flex-1 h-[39px] items-center justify-center px-6 rounded-[8px]">
                                    <p className="text-[15px] font-semibold text-white whitespace-nowrap cursor-zoom-in" title={fullValue(salesItem.total_billing_value)}>{formatLakhs(salesItem.total_billing_value)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PlantWise;
